(ns minorodata.dag.subs
  (:require [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [clojure.string]
            [datascript.core :as datascript]))


(defn format-parents [groups]
  (mapv
   (fn [{:group/keys [id name]}]
     {:data {:id                id
             :label             name
             :backgroundColor   "#e5e5e5"
             :fontSize          20
             :backgroundOpacity 1}})
   groups))


(defn add-newline-after-dots [string]
  (clojure.string/replace string #"\." ".\n"))

(defn format-nodes [nodes]
  (mapv
   (fn [{:transform/keys [id group-id name]}]
     {:data {:id                id
             :label             (add-newline-after-dots (clojure.string/upper-case name))
             :fullName          name
             :parent            group-id
             :fontSize          10
             :backgroundColor   "#7ABE79"
             :backgroundOpacity 1}})
   nodes))


(defn format-edges [transformations-view edges]
  (let [has-cycles     (:transformations-view/has-cycles transformations-view)
        edges-in-cycle (:transformations-view/edges transformations-view)]
    (mapv
     (fn [{:edge/keys [from to]}]
       (let [from-id (:transform/id from)
             to-id   (:transform/id to)]
         {:data {:source from-id
                 :target to-id
                 :label  "edge"
                 :color  (if (and has-cycles
                                  (contains? edges-in-cycle from-id)
                                  (contains? edges-in-cycle to-id))
                           "#FF0000"
                           "#a2a2a2")}}))
     edges)))


;; Recursive rules to find all predecessors or successors of given DAG node
(def edges-rules
  '[[(predecessors ?root-transform ?edge)
     [?edge :edge/to ?root-transform]]
    [(predecessors ?root-transform ?edge)
     [?edge-to :edge/to ?root-transform]
     [?edge-to :edge/from ?transform-from]
     (predecessors ?transform-from ?edge)]

    [(successors ?root-transform ?edge)
     [?edge :edge/from ?root-transform]]
    [(successors ?root-transform ?edge)
     [?edge-from :edge/from ?root-transform]
     [?edge-from :edge/to ?transform-to]
     (successors ?transform-to ?edge)]])


(defn collect-graph-ids [ds root-node view-type]
  (let [query      '{:find  [[?transform ...]]
                     :in    [$ % ?root-transform-id]
                     :where [[?root-transform :transform/id ?root-transform-id]]}
        [edge-rule edge-relation] (if (= view-type :upstream)
                                    '[(predecessors ?root-transform ?edge)
                                      [?edge :edge/from ?transform]]
                                    '[(successors ?root-transform ?edge)
                                      [?edge :edge/to ?transform]])
        full-query (update query :where conj edge-rule edge-relation)]
    (datascript/q full-query ds edges-rules root-node)))


(re-posh/reg-sub
 :dag.subs/graph-from-node
 (fn [ds [_ root-node view-type]]
   (let [[upstream downstream] (case view-type
                                 :upstream [(collect-graph-ids ds root-node :upstream)]
                                 :downstream [(collect-graph-ids ds root-node :downstream)]
                                 [(collect-graph-ids ds root-node :upstream)
                                  (collect-graph-ids ds root-node :downstream)])
         root-eid        (datascript/entid ds [:transform/id root-node])
         transforms-eids (->> (concat [root-eid] upstream downstream)
                              (remove nil?)
                              vec)]
     {:type    :pull-many
      :pattern '[:transform/id :transform/group-id :transform/master-id :transform/name :transform/output-tables :transform/input-tables]
      :ids     transforms-eids})))


(re-frame/reg-sub
 :dag.subs/elements
 (fn [_]
   [(re-frame/subscribe [:dag/pull '[:dag/root-node
                                     :dag/view-type
                                     {:dag/nodes [:transform/id :transform/group-id :transform/name :transform/output-tables]
                                      :dag/edges [{:edge/from [:transform/id]
                                                   :edge/to   [:transform/id]}]}]])
    (re-frame/subscribe [:group/pull-many '[:group/id :group/name]])
    (re-frame/subscribe [:transformations-view/pull '[:transformations-view/has-cycles :transformations-view/edges]])])
 (fn [[{:dag/keys [root-node view-type nodes edges]} groups transformations-view]]
   (let [rest-nodes     (if (or (nil? root-node)
                                (= root-node "all"))
                          nodes
                          @(re-frame/subscribe [:dag.subs/graph-from-node root-node view-type]))
         transforms-set (set (map :transform/id rest-nodes))
         groups-set     (set (map :transform/group-id rest-nodes))
         dag-parents    (->> groups
                             (filter #(contains? groups-set (:group/id %)))
                             format-parents)
         dag-nodes      (format-nodes rest-nodes)
         dag-edges      (->> edges
                             (filter (fn [{:edge/keys [from to]}]
                                       (and (contains? transforms-set (:transform/id from))
                                            (contains? transforms-set (:transform/id to)))))
                             (format-edges transformations-view))]
     (when-not (empty? rest-nodes)
       (vec (concat dag-parents dag-nodes dag-edges))))))


(re-posh/reg-query-sub
 :dag.subs/edge-containing-transform
 '[:find ?edge .
   :in $ ?transform-id
   :where
   [?tid :transform/id ?transform-id]
   [?edge :edge/to ?tid]])

;;@(re-frame/subscribe [:dag.subs/edge-containing-transform "e76cd470-554e-11e9-810a-55711a66ac6c"])

(re-frame/reg-sub
 :dag.subs/connected-nodes?
 (fn [[_ transform-id]]
   (re-frame/subscribe [:dag.subs/edge-containing-transform transform-id]))
 (fn [edge]
   (some? edge)))


(re-frame/reg-sub
 :dag.subs/tables-options
 (fn [_]
   (re-frame/subscribe [:dag/pull '[{:dag/nodes [:transform/id :transform/name :transform/output-tables]}]]))
 (fn [{:dag/keys [nodes]}]
   (mapv (fn [{:transform/keys [id name]}]
           {:value id
            ;; There's a moment when node details are not fully loaded and
            ;; `nodes` contains only transform ids. To handle this case we
            ;; need a fallback to an empty string.
            :title (clojure.string/upper-case (or name ""))})
         nodes)))
